module.exports = __webpack_public_path__ + "static/media/11.f56a7582.png";